import Route from '@ember/routing/route';

export default class AuthenticatedRepayingStudentDebtRepaymentStrategyFinderDashboardQuestionnaireResultsIndexRoute extends Route {
  model() {
    return this.modelFor(
      'authenticated.repaying-student-debt.repayment-strategy-finder.dashboard.questionnaire.results'
    );
  }
}
